module.exports = __webpack_public_path__ + "static/Aston-20199_clzjrv-3a4f47778deb0fa2b2ad308d48abd639.jpg";